import Backbone from 'backbone'
import RelatedItem from './related-item'

var RelatedItems = Backbone.Collection.extend({

	model: RelatedItem,

	// sort by related item label (case insensitive)
	comparator: function(model) {
		return (model.get('label') || '').toLowerCase()
	}

})

export default RelatedItems

RelatedItems.__filename__ = 'related-items/related-items.js'
